// The worker pre-renders a crawlable block (.seo-content: h1, text, links) inside #root.
// createRoot() clears #root on its first render, so until a page's data arrives the DOM held
// only the nav and a loader, identical on every URL. A crawler that renders the page and
// reads it in that window sees a duplicate of every other page. This keeps the block in a
// hidden sibling of #root until the real view has rendered its own h1 (no layout or loader
// renders one), then removes it.

const SHELL_ID = 'seo-shell';
// Longest the pre-rendered copy stays when no view ever renders an h1 (e.g. a not-found view)
const FALLBACK_MS = 20_000;

export function preserveSeoContent(root: HTMLElement): void {
  const content = root.querySelector(':scope > .seo-content');
  if (!content) return;

  const shell = document.createElement('div');
  shell.id = SHELL_ID;
  // Present in the DOM for crawlers, invisible and unfocusable for people
  shell.inert = true;
  shell.setAttribute('aria-hidden', 'true');
  shell.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
  shell.appendChild(content);
  document.body.appendChild(shell);

  const observer = new MutationObserver(() => {
    if (root.querySelector('h1')) release();
  });
  // Declaration (hoisted) so the observer and the timer can both call it
  function release() {
    observer.disconnect();
    clearTimeout(timer);
    shell.remove();
  }
  const timer = setTimeout(release, FALLBACK_MS);

  observer.observe(root, { childList: true, subtree: true });
}
